import {Injectable} from '@angular/core';
import {AngularFirestore, AngularFirestoreDocument} from '@angular/fire/compat/firestore';
import {AngularFireStorage, AngularFireUploadTask, AngularFireStorageReference} from '@angular/fire/compat/storage';
import {AngularFireFunctions} from '@angular/fire/compat/functions';
import {Observable} from 'rxjs';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {MatTableDataSource} from '@angular/material/table';
import {LetterV2} from '../models/letter-v2';
import {FormGroup} from '@angular/forms';
import {finalize} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LetterV2Service {

  private itemDoc: AngularFirestoreDocument<LetterV2>;
  private item: Observable<LetterV2>;

  public selectedDataSource: MatTableDataSource<any>;

  public isCongress: boolean;

  public objectImageTop: any = null;
  public storedImageTop: any;

  public objectImageBottom: any = null;
  public storedImageBottom: any;

  public objectImageBody: any = null;
  public storedImageBody: any;

  public letterDisplayedColumns: string[] = [ 'icon', 'letter-name', 'preview', 'edit', 'delete' ];
  //public letterDisplayedColumns: string[] = [ 'icon', 'letter-name', 'edit', 'delete' ];
  public letterDataSource: MatTableDataSource<any>;
  public letters: LetterV2[] = []

  constructor (private db: AngularFirestore,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions,
    private snackBar: SnackBarIconService) { }


  select (isCongress: boolean) {
    //   console.log("service is congress " + isCongress)
    return this.db.collection<LetterV2>('sbccv_letters_v2', ref => ref
      .where("isCongress", "==", isCongress)
      .orderBy('name', 'asc')).snapshotChanges();
  }


  loadLetters (event_id: string) {
    return this.db.collection<LetterV2>('sbccv_letters_v2', ref => ref
      .where('event_id', '==', event_id)
      .orderBy('name', 'asc')).snapshotChanges();
  }

  loadLettersByContext (context_id: string) {
    return this.db.collection<LetterV2>('sbccv_letters_v2', ref => ref
      .where('context_id', '==', context_id)
      .orderBy('name', 'asc')).snapshotChanges()
      .subscribe((result) => {
        this.letters = [];
        result.forEach((item) => {
          const id = item.payload.doc.id;
          const data = item.payload.doc.data();
          let entity = new LetterV2();
          entity.id = id;
          entity.name = data.name;
          entity.subject = data.subject;
          entity.type = data.type || '0';
          entity.text = data.text;
          entity.event_id = data.event_id;
          entity.event_name = data.event_name;
          entity.isCongress = data.isCongress;
          entity.isTemplate = data.isTemplate;
          entity.imageTop = data.imageTop;
          entity.imageBottom = data.imageBottom;
          entity.imageBody = data.imageBody;
          this.letters.push(entity);
        })
        this.letterDataSource = new MatTableDataSource(this.letters);
      })
  }

  loadTemplates (isCongress: boolean) {
    return this.db.collection<LetterV2>('sbccv_letters_v2', ref => ref
      .where('isTemplate', '==', true)
      .where('isCongress', '==', isCongress)
      .orderBy('name', 'asc')).snapshotChanges();
  }


  selectById (id) {
    this.itemDoc = this.db.doc<LetterV2>('sbccv_letters_v2/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  insert (entity: LetterV2) {
    return this.db.collection('sbccv_letters_v2').add(Object.assign({}, entity));
  }

  update (entity: LetterV2) {
    let id = entity.id;
    return this.db.collection('sbccv_letters_v2').doc(id).set(Object.assign({}, entity), {'merge': true});
  }

  delete (entity_id: any) {
    return this.db.collection('sbccv_letters_v2').doc(entity_id).delete();
  }

  makeMsgError (errorsCode) {
    let msgError: string

    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }

    return msgError
  }

  createInvite (data, isAdmin) {

    let url_typed: string;
    if (data.letter.type == '0') { // confirmação
      url_typed = "http://sbccv-proj.firebaseapp.com/invite_mail_back/"
    } else if (data.letter.type == '1') {// agendamento
      url_typed = "http://sbccv-proj.firebaseapp.com/invite_agenda_back/"
    } else if (data.letter.type == '2') {// atualização
      url_typed = "http://sbccv-proj.firebaseapp.com/invite_update_back/"
    }

    let url_back: any = ""
    url_back += url_typed
    url_back += data.member_id + ":"
    url_back += data.letter.id + ":"
    url_back += data.event.id;

    let link_resposta = ""
    link_resposta += "<a href='" + url_back + "'>";

    if (data.type == '0') {
      link_resposta += "Clique aqui para registrar sua resposta";
    } else if (data.type == '1') {
      link_resposta += "Clique aqui para realizar o agendamento";
    } else if (data.type == '2') {
      link_resposta += "Clique aqui para atualizar seus dados";
    }

    link_resposta += "</a>";

    let resumo_atividade: string = "";
    data.agenda.forEach(appointment => {

      resumo_atividade += "<ul>";

      resumo_atividade += "<div>";
      resumo_atividade += "<span>" + appointment.role_name + "</span>";
      if (appointment.level == 't') {
        resumo_atividade += "<span> no tópico</span>";
      } else if (appointment.level == 'a') {
        resumo_atividade += "<span> na atividade</span>";
      }
      resumo_atividade += "</div>";

      resumo_atividade += "<li>";
      resumo_atividade += "<div>Data: </div>";
      resumo_atividade += "<div>" + this.formatDate(appointment.day_date) + "</div>";
      resumo_atividade += "</li>";


      resumo_atividade += "<li>";
      resumo_atividade += "<div>Atividade: </div>";
      resumo_atividade += "<div>" + appointment.activity_startTime + " - " + appointment.activity_name + "</div>";
      resumo_atividade += "</li>";


      if (appointment.level == 't') {

        resumo_atividade += "<li>";
        resumo_atividade += "<div>Tópico: </div>";
        resumo_atividade += "<div>" + appointment.topic_startTime + " - " + appointment.topic_name + "</div>";
        resumo_atividade += "<div>" + appointment.topic_duration + " minutos" + "</div>";
        resumo_atividade += "</li>";

        resumo_atividade += "<li>";
        resumo_atividade += "<div>Equipe do Tópico</div>"

        appointment.topicStaff.forEach(st => {
          resumo_atividade += "<div style='margin-left:20px;'>";
          if (data.member_name == st.member_name) {
            resumo_atividade += st.role_name + " - " + "<span style='color:rgb(0,0,220);'>" + st.member_name + "</span>";
          } else {
            resumo_atividade += st.role_name + " - " + st.member_name;
          }
          resumo_atividade += "</div>";
        });
        resumo_atividade += "</li>";

        resumo_atividade += "<hr>";
      }

      if (appointment.level == 'a') {
        resumo_atividade += "<ul>";
        resumo_atividade += "<div>Equipe da atividade</div>";

        appointment.activityStaff.forEach(st => {
          resumo_atividade += "<li>";
          if (data.member_name == st.member_name) {
            resumo_atividade += st.role_name + " - " + "<span style='color:rgb(0,0,220);'>" + st.member_name + "</span>";
          } else {
            resumo_atividade += st.role_name + " - " + st.member_name;
          }
          resumo_atividade += "</li>";
        });
        resumo_atividade += "</ul>";

        resumo_atividade += "<hr>";

        resumo_atividade += "<ul>"

        appointment.activityTopics.forEach(ac => {
          resumo_atividade += "<li>";
          resumo_atividade += ac.topic_startTime + " - " + ac.topic_name;
          resumo_atividade += "</li>";
        });
        resumo_atividade += "</ul>";
      }

      resumo_atividade += "</ul>";
    });

    // realiza as substituições das tgs pelos seus valores reais
    let temp_text = data.letter.text;
    temp_text = temp_text.replace('[nome_associado]', data.member_name);
    temp_text = temp_text.replace('[link_resposta]', link_resposta);
    temp_text = temp_text.replace('[resumo_atividade]', resumo_atividade);

    let invite: any = {}

    invite.letter_id = data.letter.id;
    invite.letter_name = data.letter.name;
    invite.letter_subject = data.letter.subject;
    invite.letter_text = "<div>" + temp_text + "</div>"

    invite.event_id = data.event.id;
    invite.event_name = data.event.name;

    invite.member_id = data.member_id;
    invite.member_name = data.member_name;

    invite.date_sent = new Date()
    invite.url_back = url_back;
    invite.type = data.letter.type;
    invite.accept = false;
    if (isAdmin) {
      invite.obs = "Convite registrado administrativamente";
    } else {
      invite.obs = "";
    }

    return invite;

  }

  formatDate (date: Date) {
    if (date) {
      let dt = date.toISOString();
      let dd: any = dt.substr(8, 2);
      let mm: any = dt.substr(5, 2);
      let yy: any = dt.substr(0, 4);
      return dd + "/" + mm + "/" + yy;
    } else {
      return "";
    }
  }

  previewImageTop (event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      this.snackBar.openSnackBar("Apenas arquivos .png", '', 'info');
      return;
    }

    var reader = new FileReader();
    this.objectImageTop = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedImageTop = reader.result;
      return event.target.files[ 0 ];
    }
  }

  uploadImageTop (file, entity_id, form: FormGroup) {
    const fsRef: AngularFireStorageReference = this.fs.ref("lettersV2/" + entity_id + "_top.png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateImageTop(entity_id, url, form)
            .then((result) => {
              //  console.log("result: " + JSON.stringify(result))
              form.controls.imageTop.setValue(result);
            })
        });
      }))
      .subscribe();
  }

  updateImageTop (entity_id: any, image: any, form: any) {
    return this.db.collection('sbccv_letters_v2').doc(entity_id).set({'imageTop': image}, {merge: true})
      .then(() => {
        this.objectImageTop = ""
        return image;
      })
      .catch((err) => {
        console.log("erro upadate letter image top: " + JSON.stringify(err))
      })
  }


  previewImageBottom (event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      this.snackBar.openSnackBar("Apenas arquivos .png", '', 'info');
      return;
    }

    var reader = new FileReader();
    this.objectImageBottom = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedImageBottom = reader.result;
      return event.target.files[ 0 ];
    }
  }

  uploadImageBottom (file, entity_id, form: FormGroup) {
    const fsRef: AngularFireStorageReference = this.fs.ref("lettersV2/" + entity_id + "_bottom.png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateImageBottom(entity_id, url, form)
            .then((result) => {
              //  console.log("result: " + JSON.stringify(result))
              form.controls.imageBottom.setValue(result);
            })
        });
      }))
      .subscribe();
  }

  updateImageBottom (entity_id: any, image: any, form: any) {
    return this.db.collection('sbccv_letters_v2').doc(entity_id).set({'imageBottom': image}, {merge: true})
      .then(() => {
        this.objectImageBottom = ""
        return image;
      })
      .catch((err) => {
        console.log("erro upadate letter image bottom: " + JSON.stringify(err))
      })
  }


  previewImageBody (event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      this.snackBar.openSnackBar("Apenas arquivos .png", '', 'info');
      return;
    }

    var reader = new FileReader();
    this.objectImageBody = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedImageBody = reader.result;
      return event.target.files[ 0 ];
    }
  }

  uploadImageBody (file, entity_id, form: FormGroup) {
    const fsRef: AngularFireStorageReference = this.fs.ref("lettersV2/" + entity_id + "_body.png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateImageBody(entity_id, url, form)
            .then((result) => {
              //  console.log("result: " + JSON.stringify(result))
              form.controls.imageBody.setValue(result);
            })
        });
      }))
      .subscribe();
  }

  updateImageBody (entity_id: any, image: any, form: any) {
    return this.db.collection('sbccv_letters_v2').doc(entity_id).set({'imageBody': image}, {merge: true})
      .then(() => {
        this.objectImageBody = ""
        return image;
      })
      .catch((err) => {
        console.log("erro upadate letter image body: " + JSON.stringify(err))
      })
  }

}
